import {
  normalizePhone,
  validatePhone,
} from '@/utils/mobileValidation';

/** Accept PK (03…) or general international digits (UK/EU import). */
export const SUPPLIER_MOBILE_REGEX = /^(03\d{9}|0\d{9,10}|\+?\d{8,15})$/;
export const SUPPLIER_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export type SupplierFormErrors = {
  supplier_name?: string;
  mobile?: string;
  email?: string;
  opening_balance?: string;
};

export function normalizeSupplierMobile(mobile: string, countryCode?: string | null): string {
  return normalizePhone(mobile, countryCode);
}

export function validateSupplierForm(data: {
  supplier_name: string;
  mobile: string;
  email: string;
  country?: string;
}): SupplierFormErrors {
  const errors: SupplierFormErrors = {};

  if (!data.supplier_name.trim()) {
    errors.supplier_name = 'Supplier name is required.';
  }

  const mobileErr = validatePhone(data.mobile, data.country || 'GB', { required: false });
  if (mobileErr) {
    errors.mobile = mobileErr;
  }

  if (data.email.trim() && !SUPPLIER_EMAIL_REGEX.test(data.email.trim())) {
    errors.email = 'Enter a valid email address.';
  }

  return errors;
}

export function getApiErrorMessage(err: unknown, fallback: string): string {
  const data = (err as { response?: { data?: { _server_messages?: string; message?: string; exc?: string } } })?.response?.data;
  if (data?._server_messages) {
    try {
      const messages = JSON.parse(data._server_messages) as string[];
      const parsed = JSON.parse(messages[0] || '{}') as { message?: string };
      if (parsed.message) return parsed.message;
    } catch {
      // ignore parse errors
    }
  }
  if (data?.message) return String(data.message);
  if (err instanceof Error && err.message) return err.message;
  return fallback;
}
